import { HttpErrorResponse } from '@angular/common/http';

function toMessage(value: unknown): string | null {
    if (typeof value === 'string') {
        return value;
    }

    if (Array.isArray(value)) {
        return value.join('\n');
    }

    return null;
}

export function extractErrorMessage(
    error: unknown,
    fallback = 'An unexpected error occurred.',
): string {
    if (error instanceof HttpErrorResponse) {
        // Unexpected (non-HttpException) backend errors skip the API's { meta: { message } }
        // envelope and arrive as Nest's default { statusCode, message }, so read both shapes.
        // Never fall back to statusText: HTTP/2 carries no reason phrase, and Angular
        // substitutes the literal 'OK' for the empty statusText that results.
        return toMessage(error.error?.meta?.message) ?? toMessage(error.error?.message) ?? fallback;
    }

    return fallback;
}
